var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';
import { SET_STDPC_SELECT } from '../../../reducers/product';
import StdpcInfo from './info';
import Table from './table';
var SpecChange = function () {
    var stdpcOption = useSelector(function (state) { return state.product.stdpcOption; });
    var stdpcSelect = useSelector(function (state) { return state.product.stdpcSelect; });
    var baseList = (stdpcOption === null || stdpcOption === void 0 ? void 0 : stdpcOption.baseList) || [];
    var addList = (stdpcOption === null || stdpcOption === void 0 ? void 0 : stdpcOption.addList) || [];
    var _a = useState([]), activeBaseList = _a[0], setActiveBaseList = _a[1];
    var _b = useState([]), activeAddList = _b[0], setActiveAddList = _b[1];
    var dispatch = useDispatch();
    var initActiveData = function (arr, setFunc) {
        var initData = [];
        arr.forEach(function (v) {
            v.child.forEach(function (vv) {
                vv.chile.some(function (vvv) {
                    if (vvv.f_item === 1) {
                        initData.push(vvv);
                        return true;
                    }
                });
            });
        });
        setFunc(initData);
    };
    var initSet = function () {
        if (baseList) {
            initActiveData(baseList, setActiveBaseList);
        }
        if (addList) {
            var addActiveDefault = addList.map(function (v) { return ({
                cate_id: v.cate_id,
                idx_match_stdpc_item: '',
                item_nm_market: '추가 상품 선택'
            }); });
            setActiveAddList(addActiveDefault);
        }
    };
    var submitData = function () {
        if (activeBaseList || activeAddList) {
            var combineArr = __spreadArray(__spreadArray([], activeBaseList, true), activeAddList, true);
            var priceChangeData = combineArr.filter(function (v) { return Boolean(v === null || v === void 0 ? void 0 : v.price_opt) === true; });
            var changePrice = priceChangeData.map(function (v) { return ((v === null || v === void 0 ? void 0 : v.price_opt) || 0); }).reduce(function (sum, currValue) {
                return sum + currValue;
            }, 0);
            var itemIdxArr = combineArr.filter(function (v) { return Boolean(v.idx_match_stdpc_item); }).map(function (v) { return v.idx_match_stdpc_item; });
            // 2022-07-07 set_id 추가
            /*
            let one = activeBaseList.filter((v: any) => Boolean(v.idx_match_stdpc_item) && v.f_item === 1).map((v: any) => v.idx_match_stdpc_item)
            let two = activeBaseList.filter((v: any) => Boolean(v.idx_match_stdpc_item) && v.f_item === 2).map((v: any) => v.idx_match_stdpc_item)
            let three = activeBaseList.filter((v: any) => Boolean(v.idx_match_stdpc_item) && v.f_item === 3).map((v: any) => v.idx_match_stdpc_item)
            let four = activeBaseList.filter((v: any) => Boolean(v.idx_match_stdpc_item) && v.f_item === 4).map((v: any) => v.idx_match_stdpc_item)

            activeAddList.filter((v: any) => Boolean(v.idx_match_stdpc_item) && v.f_item === 1).map((v: any) => one.push(v.idx_match_stdpc_item))
            activeAddList.filter((v: any) => Boolean(v.idx_match_stdpc_item) && v.f_item === 2).map((v: any) => two.push(v.idx_match_stdpc_item))
            activeAddList.filter((v: any) => Boolean(v.idx_match_stdpc_item) && v.f_item === 3).map((v: any) => three.push(v.idx_match_stdpc_item))
            activeAddList.filter((v: any) => Boolean(v.idx_match_stdpc_item) && v.f_item === 4).map((v: any) => four.push(v.idx_match_stdpc_item))
             */
            var one_1 = activeBaseList.filter(function (v) { return Boolean(v.idx_match_stdpc_item) && v.f_item === 1; }).map(function (v) { return [v.set_id, v.idx_match_stdpc_item]; });
            var two_1 = activeBaseList.filter(function (v) { return Boolean(v.idx_match_stdpc_item) && v.f_item === 2; }).map(function (v) { return [v.set_id, v.idx_match_stdpc_item]; });
            var three_1 = activeBaseList.filter(function (v) { return Boolean(v.idx_match_stdpc_item) && v.f_item === 3; }).map(function (v) { return [v.set_id, v.idx_match_stdpc_item]; });
            var four_1 = activeBaseList.filter(function (v) { return Boolean(v.idx_match_stdpc_item) && v.f_item === 4; }).map(function (v) { return [v.set_id, v.idx_match_stdpc_item]; });
            //activeAddList.filter((v: any) => Boolean(v.idx_match_stdpc_item) && v.f_item === 1).map((v: any) => one.push(v.idx_match_stdpc_item))
            activeAddList.filter(function (v) { return Boolean(v.idx_match_stdpc_item) && v.f_item === 1; }).map(function (v) { return one_1.push([v.set_id, , v.idx_match_stdpc_item]); });
            activeAddList.filter(function (v) { return Boolean(v.idx_match_stdpc_item) && v.f_item === 2; }).map(function (v) { return two_1.push([v.set_id, v.idx_match_stdpc_item]); });
            activeAddList.filter(function (v) { return Boolean(v.idx_match_stdpc_item) && v.f_item === 3; }).map(function (v) { return three_1.push([v.set_id, v.idx_match_stdpc_item]); });
            activeAddList.filter(function (v) { return Boolean(v.idx_match_stdpc_item) && v.f_item === 4; }).map(function (v) { return four_1.push([v.set_id, v.idx_match_stdpc_item]); });
            dispatch({
                type: SET_STDPC_SELECT,
                payload: {
                    price: stdpcSelect.originPrice + changePrice,
                    addedChangeLenght: priceChangeData.length,
                    addedChangePrice: changePrice,
                    selectIdxArr: itemIdxArr,
                    stdpc_item_list_type1: one_1,
                    stdpc_item_list_type2: two_1,
                    stdpc_item_list_type3: three_1,
                    stdpc_item_list_type4: four_1,
                }
            });
        }
    };
    var reset = function () {
        initSet();
    };
    useEffect(function () {
        initSet();
    }, [stdpcOption]);
    useEffect(function () {
        submitData();
    }, [activeBaseList, activeAddList]);
    return (React.createElement(Style, null,
        React.createElement(StdpcInfo, null),
        (baseList === null || baseList === void 0 ? void 0 : baseList.length) > 0 && (React.createElement(SpecField, null,
            React.createElement("div", { className: "head" },
                React.createElement("div", { className: "title" }, "\uAE30\uBCF8\uC0AC\uC591 \uBCC0\uACBD"),
                React.createElement("button", { type: "button", className: "reset", onClick: reset }, "\uC0AC\uC591\uBCC0\uACBD \uCD08\uAE30\uD654")),
            React.createElement(Table, { type: "base", data: baseList, active: activeBaseList, setActive: setActiveBaseList }))),
        (addList === null || addList === void 0 ? void 0 : addList.length) > 0 && (React.createElement(SpecField, null,
            React.createElement("div", { className: "head" },
                React.createElement("div", { className: "title" }, "\uCD94\uAC00\uC0AC\uC591 \uBCC0\uACBD")),
            React.createElement(Table, { type: "add", data: addList, active: activeAddList, setActive: setActiveAddList })))));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    .head {\n        display: flex;\n        justify-content: space-between;\n\n        .title {\n            margin: 0 0 8px;\n            color: #333;\n            font-size: 18px;\n            font-weight: 700;\n        }\n        .reset {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border: 1px solid #999;\n            width: 120px;\n            height: 24px;\n            background: #fff;\n            font-size: 14px;\n            color: #707070;\n\n            &:hover {\n                text-decoration: underline;\n            }\n        }\n    }\n"], ["\n    .head {\n        display: flex;\n        justify-content: space-between;\n\n        .title {\n            margin: 0 0 8px;\n            color: #333;\n            font-size: 18px;\n            font-weight: 700;\n        }\n        .reset {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border: 1px solid #999;\n            width: 120px;\n            height: 24px;\n            background: #fff;\n            font-size: 14px;\n            color: #707070;\n\n            &:hover {\n                text-decoration: underline;\n            }\n        }\n    }\n"])));
var SpecField = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 40px 0 0;\n"], ["\n    margin: 40px 0 0;\n"])));
export default SpecChange;
var templateObject_1, templateObject_2;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/stdpc/spec_change/index.tsx
// module id = 221
// module chunks = 0